/* ============================================================
   AURA VEA — interacciones (vanilla, sin librerías)
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveals al hacer scroll (un solo observer compartido) ---- */
  function initReveals() {
    var els = document.querySelectorAll('.av-reveal');
    if (!els.length) return;

    // Activa el modo animación: a partir de aquí el CSS oculta los .av-reveal.
    // Si algo de esto falla, el contenido ya es visible por defecto (sin `av-js`).
    var root = document.documentElement;
    root.classList.add('av-js');

    function revealAll() {
      els.forEach(function (el) { el.classList.add('av-visible'); });
    }

    if (reduce || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('av-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { obs.observe(el); });

    // Red de seguridad: si por lo que sea (pestaña en segundo plano, navegador
    // que pausa animaciones, observer que no dispara) algo no se ha revelado,
    // muéstralo todo pasado un tiempo. Nunca dejar contenido invisible.
    setTimeout(revealAll, 2500);
    window.addEventListener('load', function () { setTimeout(revealAll, 400); });
  }

  /* ---- Galería de producto ---- */
  function initGallery() {
    var gallery = document.querySelector('[data-av-gallery]');
    if (!gallery) return;
    var mainImg = gallery.querySelector('[data-av-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-av-thumb]');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) mainImg.src = full;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---- Selector de variantes ---- */
  function initVariants() {
    var buy = document.querySelector('[data-av-buy]');
    if (!buy) return;
    var dataEl = buy.querySelector('[data-av-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var buttons = buy.querySelectorAll('[data-av-variant]');
    var idInput = buy.querySelector('[data-av-variant-id]');
    var priceNow = buy.querySelector('[data-av-price-now]');
    var priceWas = buy.querySelector('[data-av-price-was]');
    var submit = buy.querySelector('[data-av-submit]');
    var soldLabel = submit ? submit.getAttribute('data-sold-text') : 'Agotado';
    var buyLabel = submit ? submit.getAttribute('data-buy-text') : 'Añadir al carrito';

    function money(cents) {
      return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function select(v) {
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = money(v.compare_at_price);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }
      if (submit) {
        if (v.available) {
          submit.disabled = false;
          submit.textContent = buyLabel;
        } else {
          submit.disabled = true;
          submit.textContent = soldLabel;
        }
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-av-variant');
        var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
        if (!v) return;
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        select(v);
      });
    });
  }

  /* ---- Pack "Ritual Aura Vea": elegir color y añadir todo al carrito ---- */
  function initPack() {
    var packs = document.querySelectorAll('[data-av-pack]');
    if (!packs.length) return;

    packs.forEach(function (pack) {
      // Selector de color por producto del pack
      pack.querySelectorAll('[data-av-pack-item]').forEach(function (item) {
        var colors = item.querySelectorAll('[data-av-pack-color]');
        colors.forEach(function (btn) {
          btn.addEventListener('click', function () {
            colors.forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            item.setAttribute('data-variant', btn.getAttribute('data-av-pack-color'));
          });
        });
      });

      // Añadir todos los productos del pack de una vez
      var addBtn = pack.querySelector('[data-av-pack-add]');
      if (!addBtn) return;
      addBtn.addEventListener('click', function () {
        var items = [];
        pack.querySelectorAll('[data-av-pack-item]').forEach(function (item) {
          var id = item.getAttribute('data-variant');
          if (id) items.push({ id: Number(id), quantity: 1 });
        });
        if (!items.length) return;

        var original = addBtn.getAttribute('data-buy-text') || addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-loading-text') || 'Añadiendo…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            window.location.href = '/cart';
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = original;
          });
      });
    });
  }

  /* ---- Mini-bundle bajo el botón de compra ---- */
  function initMiniBundle() {
    var cards = document.querySelectorAll('[data-av-minibundle]');
    if (!cards.length) return;
    var idInput = document.querySelector('[data-av-variant-id]'); // variante actual (sigue al selector)

    cards.forEach(function (card) {
      var btn = card.querySelector('[data-av-minibundle-add]');
      if (!btn) return;
      var partnerId = card.getAttribute('data-partner-variant');
      btn.addEventListener('click', function () {
        var currentId = idInput ? idInput.value : null;
        var items = [];
        if (currentId) items.push({ id: Number(currentId), quantity: 1 });
        if (partnerId) items.push({ id: Number(partnerId), quantity: 1 });
        if (!items.length) return;

        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-loading-text') || 'Añadiendo…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            window.location.href = '/cart';
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = original;
          });
      });
    });
  }

  /* ---- Oferta de cantidad: selecciona tramo y fija la cantidad ---- */
  function initQoffer() {
    var offer = document.querySelector('[data-av-qoffer]');
    if (!offer) return;
    var qtyInput = document.querySelector('[data-av-qty]');
    var opts = offer.querySelectorAll('[data-av-qopt]');
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        if (qtyInput) qtyInput.value = opt.getAttribute('data-qty') || '1';
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initReveals();
    initGallery();
    initVariants();
    initPack();
    initMiniBundle();
    initQoffer();
  });
})();
